import React from "react";
import ContentContainer from "./contentContainer";
import { Box } from "@mui/material";
import Grid from '@mui/material/Grid2';
import PageTitle from "./pageTitle";
import './g3SystemRequirements.css';

export default function G3SystemRequirements() {
    return (
        <ContentContainer>
            <PageTitle title='System Requirements' />

            <Box component="main" sx={{ p: 3, width: '100%' }} className="system-requirements">
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Computer Diagnostic System G3</h3>
                        <p>
                            CDS G3 is a standalone, PC-based application that complements the original Mercury Computer Diagnostic System (CDS). It provides diagnostic support for select engines and Mercury Joystick Piloting systems, while also enabling all required configuration functions for system setup and delivery.
                            <br />
                            <br />
                            The application supports CAN-based communication across multiple processors and features a clean, user-friendly interface designed for efficient navigation and operation.
                            <br />
                            <br />
                            For optimal performance and reliability, we recommend the <a href="https://connect.na.panasonic.com/toughbook/rugged-laptops-tablets/toughbook-56">Panasonic Toughbook 56</a>
                        </p>
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item size={6}>
                        <h3>Laptop System Requirements</h3>
                        <ul>
                            <li>
                                <ul>
                                    <li>Intel® Core™ i5 11th Gen or higher or AMD Ryzen 5 2000 series or higher</li>
                                    <li>16 GB RAM or better</li>
                                    <li>Screen Size 10.1 inch or bigger</li>
                                    <li>Screen Resolution 1366 x 768 or better</li>
                                    <li>512 GB solid state hard drive or better</li>
                                    <li>Qty. 1 or more USB ports 2.0 or 3.0</li>
                                    <li>Windows® 11 Pro</li>
                                    <li>An Internet Connection</li>
                                </ul>
                                <p><em>** A single USB port plus a USB port hub may be used.<br /></em></p>
                                <p>G3 is compatible with ARM-based processors (e.g., Snapdragon) in a beta state. If you experience any issues, please report them through the “Contact Us” link in the G3 menu so we can continue improving support.</p>
                            </li>
                        </ul>
                        <p><em>&nbsp;</em></p>
                    </Grid>
                    <Grid item size={6}>
                        <h3>Features</h3>
                        <ul className="feature-list">
                            <li>View, record and play engine/module data</li>
                            <li>View faults and run history</li>
                            <li>Run diagnostics tests</li>
                            <li>Configure engine and controls</li>
                            <li>Reflash modules</li>
                        </ul>
                    </Grid>
                </Grid>
            </Box>
        </ContentContainer>
    );
}